/** Sign in, sign up and the email verification code step. */
export default {
  tabs: {
    signIn: "Sign in",
    signUp: "Sign up",
  },
  signIn: {
    title: "Welcome back",
    subtitle: "Sign in to manage your profile and generations.",
    submit: "Sign in",
  },
  signUp: {
    title: "Create your account",
    subtitle: "Get 10 free points to start generating — no card needed, and you are never charged unless you buy a points pack yourself.",
    submit: "Create account",
    acceptTerms: "I confirm that I am at least 18 years old and accept the <terms>Terms of Use</terms> and <privacy>Privacy Policy</privacy>.",
  },
  fields: {
    fullName: "Full name",
    fullNamePlaceholder: "Your name",
    email: "Email",
    emailPlaceholder: "you@example.com",
    password: "Password",
    confirmPassword: "Confirm password",
  },
  forgot: {
    link: "Forgot password?",
    title: "Reset your password",
    subtitle: "Enter the email on your account. If we find it, we will send a link to choose a new password.",
    submit: "Send reset link",
    sent: "If an account exists for {{email}}, we sent a reset link. It expires in {{minutes}} minutes and can be used only once. Check your inbox and your spam folder.",
    backToSignIn: "← Back to sign in",
  },
  reset: {
    title: "Choose a new password",
    subtitle: "This link expires {{minutes}} minutes after it was sent, and it can be used only once.",
    submit: "Save new password",
    mismatch: "The two passwords do not match.",
    expired: "This reset link is invalid or has expired. Request a new one from the sign-in page.",
    requestNew: "Request a new link",
    missing: "This reset link is incomplete. Request a new one from the sign-in page.",
  },
  verify: {
    title: "Check your email",
    intro: "Enter the 6-digit code we sent to <email>{{email}}</email>. It expires in 10 minutes.",
    codeLabel: "Verification code",
    submit: "Verify and create account",
    verifying: "Verifying…",
    useDifferentEmail: "← Use a different email",
    resend: "Resend code",
    resendIn: "Resend code in {{seconds}}s",
    codeSent: "We sent a 6-digit code to {{email}}.",
    newCodeSent: "We sent a new code to {{email}}.",
    resendFailed: "Could not resend the code.",
    digitLabel: "Digit {{position}} of {{length}}",
  },
  password: {
    rules: {
      length: "At least {{min}} characters",
      letter: "At least one letter",
      number: "At least one number",
      personal: "Not your name, your email or a common password",
    },
    problems: {
      tooShort: "Your password must be at least {{min}} characters long.",
      tooLong: "Your password can be at most {{max}} characters long.",
      needsLetter: "Your password must contain at least one letter.",
      needsNumber: "Your password must contain at least one number.",
      containsPersonal: "Your password must not contain your name or email address.",
      tooCommon: "That password is too common and easy to guess. Please choose a less predictable one.",
    },
  },
  bonus: {
    title: "Welcome! Your points are waiting",
    body_one: "{{points}} points from your earlier purchase are already in your account.",
    body_other: "{{points}} points from your {{count}} earlier purchases are already in your account.",
    note: "They were added when you paid with this email address. Together with your 10 free points, you can start creating right away.",
    cta: "Start generating",
    close: "Close",
  },
  errors: {
    acceptTerms: "Please confirm that you are at least 18 years old and accept the Terms of Use.",
    fullNameRequired: "Please enter your full name.",
  },
};
